<template>
  <section class="app-main">
    <!--    <div v-if="location.hostname === 'localhost'">当前缓存页面: {{ cachedViews }}</div>-->
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews" :max="2">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppMain',
  data() {
    return {
      location: location
    }
  },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar']),
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  //min-height:100vh;
  width: 100%;
  position: relative;
}
.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>
